<template>

     <v-container fluid fill-height>
         <v-layout>
            <v-flex v-if="loading" xs12>
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
            <v-flex v-else-if="errorMessage" xs12>
                <v-alert 
                    :value="true" 
                    outline 
                    type="error">
                    <span>{{ errorMessage }}</span>
                </v-alert>
            </v-flex>
            <v-flex v-else xs12>
                <v-card>
                    <v-toolbar color="primary" class="white--text">
                        <v-toolbar-title>Roles</v-toolbar-title>
                    </v-toolbar>
                    <v-layout pt-3 column>
                        <v-flex xs12>
                            <v-layout row align-center justigy-center>
                                <v-flex ma-1 align-center >
                                    <v-autocomplete
                                        label="Companies"
                                        :items="companies"
                                        multiple
                                        outline
                                        item-value="CompanyID"
                                        item-text="CompanyName"
                                        v-model="selectedCompanyIDs">
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      
                        <v-flex xs12>
                                <RolesTable
                                    :data="filteredRoles"
                                    @edit="openEdit"
                                    @showRates="showRates"
                                >
                                </RolesTable>
                        </v-flex>
                    </v-layout>
                </v-card>
                
            </v-flex>
        </v-layout>

        <RoleAddEdit
            :show="showAddEditDialog"
            :originalItem="editedRole"
            :salaryCodes="salaryCodes"
            :companies="companies"
            :roleTypeCategories="roleTypeCategories"
            :roles="roles"
            @close="onAddEditClose"
        >
        </RoleAddEdit>

        <RoleTypeRatesList 
            :show="showRatesListDialog"
            :originalItem="editedRole"
            @close="onRateListClose">
        </RoleTypeRatesList>

    </v-container>
</template>

<script>
import configurationApi from "@/api/configurationApi";
import BaseAPI from "@/api/baseApi";

import RoleAddEdit from "@/components/configuration/roles/RoleAddEdit.vue";
import RolesTable from "@/components/configuration/roles/RolesTable.vue";
import RoleTypeRatesList from "@/components/configuration/roles/RoleTypeRatesList.vue";

export default {
  data: function() {
        return {
            loading: false,
            errorMessage: null,

            roles: [],
            salaryCodes: [],
            
            showAddEditDialog: false,
            showRatesListDialog: false,
            editedRole: null,
            companies: [],
            roleTypeCategories: [],
            selectedCompanyIDs: [],
            selectedRoleTypeCategories: []
        }
    },
    computed: {
        filteredRoles() {
            return this.roles.filter(r=> this.selectedCompanyIDs.length == 0 || this.selectedCompanyIDs.indexOf(r.CompanyID) > -1);
        }
    },
    methods: {
        openEdit(role) {
            this.editedRole = role;
            this.showAddEditDialog = true;
        },
        onAddEditClose() {
            this.editedRole = null;
            this.showAddEditDialog = false;
        },
        showRates(role){
            this.editedRole = role;
            this.showRatesListDialog = true;
        },
        async onRateListClose(saved) {
            this.showRatesListDialog = false;
            this.showAddEditDialog = false;
            this.editedRole = null;

            if (saved) {
                await this.loadData();
            }
        },
        async loadData() {
            try {
                this.loading = true;
                this.errorMessage = null;

                const [rolesResult, salaryCodesResult, companiesResult, roleTypeCategoriesResult] = await Promise.all([
                    configurationApi.getRoles(),
                    configurationApi.getSalaryCodes(),
                    configurationApi.getCompanies(),
                    configurationApi.getRoleTypeCategories()
                ]);

                this.roles = rolesResult;

                let salaryCodesOptions = salaryCodesResult;

                this.companies = companiesResult;

                this.roleTypeCategories = roleTypeCategoriesResult;
                
                // add a None option to salary code selector
                salaryCodesOptions.push({
                    SalaryCodeID: null,
                    SalaryCode: "None"
                });

                salaryCodesOptions.sort(function(a, b) {
                    if (!a.SalaryCodeID) {
                        return -1;
                    }

                    if (!b.SalaryCodeID) {
                        return 1;
                    }

                    return b.SalaryCode - a.SalaryCode;
                });

                this.salaryCodes = salaryCodesOptions;
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        }
    },
    async created() {
        await this.loadData();
    },
    components: {
        RoleAddEdit,
        RolesTable,
        RoleTypeRatesList
    }
}
</script>

<style>

</style>
